// Import React and the PropertiesSection component
import React from "react";
import PropertiesSection from "../components/Properties/head"; // Adjust the path if the file is located in a different folder
import NiceAppartment from "../components/Properties/NiceAppartment";

const Services = () => {
  return (
   
    <div>

      {/* Include the PropertiesSection component */}
      <PropertiesSection />
      <NiceAppartment/>
      
      </div>
  );
};

export default Services;
